import { ApiClient } from '@/services/ApiClient.js';
import { defineService } from '@nzyme/ioc/Service.js';
import { FileMetadataLoader } from '@sigma/client/files/FileMetadataLoader.js';
import { FileGetEndpoint } from '@sigma/patient-api/files/FileGetEndpoint.js';

/**
 * Patient-app implementation of {@link FileMetadataLoader}.
 *
 * Routes batched file-metadata fetches through the patient `FileGetEndpoint`.
 * Caching, batching and cache invalidation live in the shared
 * {@link import('@sigma/client/files/FileMetadataStore.js').FileMetadataStore}.
 */
export const PatientFileMetadataLoader = defineService({
    name: 'PatientFileMetadataLoader',
    implements: FileMetadataLoader,
    deps: {
        apiClient: ApiClient,
    },
    setup({ apiClient }): FileMetadataLoader {
        return fileIds => apiClient(FileGetEndpoint, { fileIds });
    },
});
